/* unplugin-vue-components disabled */import { render } from "./E808CTriangle.vue?vue&type=template&id=2a8e3333&scoped=true"
import script from "./E808CTriangle.vue?vue&type=script&lang=js"
export * from "./E808CTriangle.vue?vue&type=script&lang=js"

import "./E808CTriangle.vue?vue&type=style&index=0&id=2a8e3333&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8e3333"]])

export default __exports__